import React from 'react';
import './footer.less';
import {Link} from 'react-router';

export default class Footer extends React.Component {
  constructor(props) {
    super(props);
  }

  render(){
    return(
      <div className = "footer">
      <div className = "wrapper">
        <div className = "footer-content-wrap">
          <div className = "footer-left-content-wrap">
            <div className = "logo-img-wrap">
              <img src = "../../public/images/landing/awb_logo_white.png" className = "logo-img" />
            </div>
            <div className = "footer-link no-padding"><Link target="_blank" to="http://blog.airwaybill.com/">BLOG</Link></div>
            <div className = "footer-link"><Link target="_blank" to="/learn-more">LEARN MORE</Link></div>
            <div className = "footer-link"><Link target="_blank" to="/about">ABOUT</Link></div>
            <div className = "footer-link"><Link target="_blank" to="/terms-and-conditions">TERMS AND CONDITIONS</Link></div>
            <div className = "footer-link"><Link target="_blank" to="/privacy-policy">PRIVACY POLICY</Link></div>
            <div className = "footer-link"><Link target="_blank" to="/faq">FAQ</Link></div>
            <div className = "footer-link"><Link target="_blank" to="/contact">CONTACT</Link></div>
          </div>
          <div className = "footer-right-content-wrap">
            <div className = "copyright-content">
              &copy;2017 AirWayBill, S.L.
            </div>
          </div>
        </div>
      </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// app/footer/footer.jsx